<template>
  <div>
    <div class="content-header">
      <h2>干训政策</h2>
    </div>
    <div class="content-con">
      <div class="ant-spin-nested-loading">
        <div class="ant-spin-container">
          <ul class="content-list">
            <li
              class="recommend-item"
              v-for="(item, index) in dataList"
              :key="index"
            >
              <router-link
                v-if="item.visible == 1"
                :to="
                  '/content/' + queryFilter.typeIdArr + '/' + item.cmCommentId
                "
              >
                <div class="container">
                  <div class="top">
                    <div class="name substring">
                      <div class="day" v-if="item.releaseTime">
                        {{ item.releaseTime.split(" ")[0].split("-")[2] }}
                      </div>
                      <div class="year-month" v-if="item.releaseTime">
                        {{ item.releaseTime.split(" ")[0].split("-")[0] }}-{{
                          item.releaseTime.split(" ")[0].split("-")[1]
                        }}
                      </div>
                    </div>
                    <div class="wage substring">
                      <div class="list-title">{{ item.commentTitle }}</div>
                      <div class="content">{{ item.outline }}</div>
                    </div>
                  </div>
                </div>
              </router-link>
            </li>
          </ul>
        </div>
      </div>
      <!-- 分页器 -->
      <div class="pagination-wrapper">
        <pagination
          v-show="total > 0"
          :total="total"
          :page.sync="queryFilter.pageNum"
          :limit.sync="queryFilter.pageSize"
          @pagination="getList"
        />
      </div>
    </div>
  </div>
</template>
<script>
import { getCommentListWithPage } from "@/api/index";
export default {
  data() {
    return {
      dataList: [],
      queryFilter: {
        pageNum: 1,
        pageSize: 10,
        typeIdArr: "7",
        visible: "1",
        location: "",
        orderByColumn: "releaseTime",
        isAsc: "desc",
      },
      // 总条数
      total: 0,
    };
  },
  created() {
    this.getList();
  },
  methods: {
    getList() {
      const loading = this.$loading();
      getCommentListWithPage(this.queryFilter)
        .then((res) => {
          loading.close();
          if (res.code == 200) {
            this.dataList = res.rows;
            this.total = res.total;
          }
        })
        .catch(() => {
          loading.close();
        });
    },
  },
};
</script>
<style lang="less" scoped>
.content-con {
  .ant-spin-nested-loading {
    position: relative;
    .ant-spin-container {
      position: relative;
      -webkit-transition: opacity 0.3s;
      -o-transition: opacity 0.3s;
      transition: opacity 0.3s;
      .content-list {
        margin-top: 20px;
        display: flex;
        flex-wrap: wrap;
        .recommend-item {
          padding: 20px 25px;
          width: 100%;
          border-bottom: 1px solid #dcdcdc;
        }

        .container {
          .top {
            -ms-flex-align: center;
            -ms-flex-pack: justify;
            align-items: center;
            display: -ms-flexbox;
            display: flex;
            justify-content: space-between;
            .name {
              box-sizing: border-box;
              background: linear-gradient(to bottom, #bce3fc, #7499ce);
              width: 80px;
              height: 90px;
              display: flex;
              flex-direction: column;
              justify-content: center;
              align-items: center;
              color: #fff;
              margin-right: 40px;
              .day {
                font-size: 42px;
              }
              .year-month {
                font-size: 16px;
              }
            }
            .wage {
              width: calc(100% - 7.7em);
              height: 80px;
              .list-title {
                overflow: hidden;
                text-overflow: ellipsis;
                white-space: nowrap;
                font-size: 20px;
                margin-bottom: 12px;
              }
              .content {
                font-size: 16px;
                color: #585858;
                word-break: break-all;
                overflow: hidden;
                display: -webkit-box;
                -webkit-line-clamp: 2;
                -webkit-box-orient: vertical;
              }
            }
          }
        }

        .container:hover {
          color: #00a0e9;
          .name {
            color: #00a0e9;
            border: 2px solid #00a0e9;
            background: #fff;
          }
        }
      }
    }
  }

  .pagination-wrapper {
    text-align: center;
  }
}
</style>